module.exports = __webpack_public_path__ + "img/sponsorJ20.e3369712.png";